
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { auditTime } from 'rxjs/operators';

export class ScrollInstruction {
  id: string;
  focus: boolean;
}

/**
 * The Window service wraps behavior of native window object
 * Implemented by following http://juristr.com/blog/2016/09/ng2-get-window-ref/
 */
@Injectable()
export class WindowRef {

  private scrollSubject = new Subject<ScrollInstruction>();

  constructor() {
    this.scrollSubject
      .pipe(auditTime(100))
      .subscribe((scroll) => this.scrollTo(scroll));
  }

  get nativeWindow(): Window {
    return this._window();
  }

  scrollToElement(id: string, focus = true) {
    this.scrollSubject.next({ id, focus });
  }

  private scrollTo(scroll: ScrollInstruction) {
    const el = window.document.getElementById(scroll.id);
    if (el) {
      window.scrollTo({
        top: el.getBoundingClientRect().bottom,
        behavior: 'smooth'
      });

      if (scroll.focus) {
        this.focusFormControl(scroll.id);
      }
    }
  }

  private focusFormControl(elId: string) {
    const listQuestion = window.document.getElementById(elId);
    if (listQuestion) {
      const form = listQuestion.getElementsByTagName('form').item(0);
      if (form) {
        let control: HTMLElement;
        control = form.getElementsByTagName('input').item(0);
        if (!control) {
          control = form.getElementsByTagName('select').item(0);
        }
        control.focus();
      }
    }
  }

  _window(): Window {
    // return the global native browser window object
    return window;
  }
}
